import type { Supabase } from '~/types/supabase-client';
import TableService from './table.service';
import type { DbResultOk } from '~/types/database-helpers';
import type Stripe from 'stripe';

export class SubscriptionsService extends TableService<'subscriptions'> {
  constructor(supabase: Supabase) {
    super(supabase, 'subscriptions', {
      pk: 'id',
      defaultSort: { field: 'id', ascending: false, nullsFirst: true },
    });
  }

  public async findByStripeSubscriptionId(
    stripeSubscriptionId: string,
    order: 'asc' | 'desc' = 'desc'
  ) {
    try {
      if (!stripeSubscriptionId) {
        throw createError({
          statusCode: 400,
          statusMessage: 'Invalid stripe subscription ID',
        });
      }
      const { data, error } = await this.supabase
        .from('subscriptions')
        .select(`*`)
        .eq('stripe_subscription_id', stripeSubscriptionId)
        .order('id', { ascending: order == 'asc' });

      if (error) throw error;
      return { data, error: null };
    } catch (error: any) {
      console.error(error);
      throw createError({
        statusCode: 500,
        statusMessage: error.message,
      });
    }
  }

  public async updateStatusByStripeSubscriptionId(
    stripeSubscriptionId: string,
    status: Stripe.Subscription.Status
  ) {
    try {
      if (!stripeSubscriptionId) {
        throw createError({
          statusCode: 400,
          statusMessage: 'Invalid stripe subscription ID',
        });
      }
      const { data, error } = await this.supabase
        .from('subscriptions')
        .update({ status })
        .eq('stripe_subscription_id', stripeSubscriptionId)
        .select();

      if (error) throw error;
      return { data, error: null };
    } catch (error: any) {
      console.error(error);
      throw createError({
        statusCode: 500,
        statusMessage: error.message,
      });
    }
  }
}
